import React from 'react'
import history from '../Components/history';
import jwtDecode from "jwt-decode";

export function checkSessionStatus() {
    const profileId = localStorage.getItem('ProfileId');

    if (!profileId) {
      // ProfileId does not exist or session has expired, redirect the user
      history.push('/login'); 
      return false;
    }
    return true
}

export const isTokenValid = () => {
  const token = localStorage.getItem("token");
  if (!token) return false;
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken.exp > currentTime;
  } catch (error) {
    return false;
  }
};

export const isProfileValid = () => {
  const profileId = localStorage.getItem('ProfileId');
  return profileId !== null;
};

export default checkSessionStatus;